(function () {
  /* selector į visą Express‑Checkout bloką */
  const fastPayBlock = document.querySelector('.additional-checkout-buttons');
  if (!fastPayBlock) return;

  /* pradinė būsena – užrakinam mygtukus */
  toggleFastPay(false);

  /* kas 400 ms tikrinam Parcely flag’ą (saugus, paprastas būdas) */
  const checker = setInterval(() => {
    if (window.PARCELY_APP && window.PARCELY_APP.readyForCheckout) {
      toggleFastPay(true);
      clearInterval(checker);
    }
  }, 400);

  /* universali funkcija įjungti / išjungti */
  function toggleFastPay(enable) {
    if (enable) {
      fastPayBlock.classList.remove('fastpay--disabled');
      /* jei ShopPay / GooglePay mygtukai turi  disabled attr: */
      fastPayBlock.querySelectorAll('[disabled]').forEach(el => el.removeAttribute('disabled'));
    } else {
      fastPayBlock.classList.add('fastpay--disabled');
    }
  }
})();
